// @flow

import React from 'react'
import ReputationStar from './ReputationStar'

type PropTypes = {
  score: number,
  count: number,
  link: string,
}

export default (props: PropTypes) => (
  <span>
    <ReputationStar score={props.score} link={props.link} />
    <a href={props.link} className="space-head__list-number">
      {i18n.t('page.room.numberOf', { count: props.count })}
    </a>
  </span>
)



// WEBPACK FOOTER //
// ./src/components/shared/ReputationStarWithCount.jsx